import moment from "moment";
import userTypes from "venuescanner-js/constants/user_type";
import subplans from "venuescanner-js/constants/subscriptions";
import insertToArrayIndex from "venuescanner-js/react/components/Inbox/helpers/insertToArrayIndex";

const enquiryDetailModel = (thread) => {
  const enquiryDetailModel = [
    {
      title: "Space",
      value: thread._space.name,
      hasLink: thread._space?.url ? thread._space.url : null,
    },
    { title: "Event Type", value: thread.event_type },
    { title: "Budget", value: thread.cumulativeOffer.org_budget },
    { title: "Guests", value: thread.cumulativeOffer.capacity },
    {
      title: "Date",
      value:
        moment(thread.localDates.from).format("D/M/YYYY") ===
        moment(thread.localDates.to).format("D/M/YYYY")
          ? moment(thread.localDates.from).format("D/M/YYYY")
          : `${moment(thread.localDates.from).format("D")} - ${moment(
              thread.localDates.to
            ).format("D/M/YYYY")}`,
    },
    {
      title: "Time",
      value:
        moment(thread.localDates.from).format("HH:mm") +
        " - " +
        moment(thread.localDates.to).format("HH:mm"),
    },
    {
      title: "Deposit",
      value: thread.cumulativeOffer.first_deposit_amount,
      isCurrency: true,
    },
    {
      title: "Full Cost",
      value: thread.cumulativeOffer.cost,
      isCurrency: true,
    },
  ];

  // add org contact details to host if they have a sub plan

  if (thread.viewerRole === userTypes.host) {
    const showOrgContactDetailsToHost =
      (thread.hide_from_organiser && thread._concierge) ||
      [subplans.GOLD, subplans.PRO, subplans.UNLIMITED].includes(
        thread._venue.sub_plan
      );
    const contact =
      thread.hide_from_organiser && thread._concierge
        ? thread._concierge
        : thread._organiser;
    const orgEmail = contact.email.length
      ? { title: "Email", value: contact.email }
      : false;
    const orgPhone = contact.phone.length
      ? { title: "Phone", value: contact.phone }
      : false;
    const conciergeName =
      thread.hide_from_organiser && thread._concierge
        ? contact.name.length
          ? { title: "Concierge", value: contact.name }
          : false
        : false;
    showOrgContactDetailsToHost
      ? insertToArrayIndex(
          enquiryDetailModel,
          1,
          conciergeName,
          orgEmail,
          orgPhone
        )
      : null;
  }
  return enquiryDetailModel;
};

export default enquiryDetailModel;
